module.exports = __webpack_public_path__ + "sgby/img/lvbu-s.a8c4a5b.png";